/**
 * YourSupport Module Routes Configuration
 * Defines all routes for the support ticket system
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import PrivateRoute from '../../../../components/PrivateRoute';

// Pages (TicketForm & TicketDetails are now ModalWrapper modals, opened from within these pages)
import Dashboard from '../pages/Dashboard';
import TicketList from '../pages/TicketList';

/**
 * DS Helpdesk route configuration
 * Base path: /app/yoursupport
 */
export const yourSupportRoutes: RouteObject[] = [
  {
    path: '/app/yoursupport',
    element: <PrivateRoute><Layout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'tickets',
        element: <TicketList />
      }
    ]
  }
];

export default yourSupportRoutes;
